import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, AfterViewChecked, SimpleChange ,SimpleChanges} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-multi-select-dropdown',
  standalone: true,
  imports: [CommonModule, NgMultiSelectDropDownModule, FormsModule],
  templateUrl: './multi-select-dropdown.component.html',
  styleUrl: './multi-select-dropdown.component.scss'
})
export class MultiSelectDropdownComponent implements AfterViewChecked {
  @Input() placeHolderTitle: string = "";
  @Input() dropdownList: any = [];
    // Internal state management
  private originalSelectedItems: any[] = [];
  @Input() tempSelectedItems: any[] = [];
  currentSelectedItems: any[] = [];
  @Input() selectedItems: any = [];
  @Input() dropdownSettings: any = {};
  @Input() clearfilter : boolean = false
  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter();
  isToggle: boolean = false;
  ngOnInit() {
    // Initialize the internal state when component first loads
    this.originalSelectedItems = [...this.selectedItems];
    this.currentSelectedItems = [...this.selectedItems];
  }

  @Output() onApply: EventEmitter<any> = new EventEmitter();
@Output() onReset: EventEmitter<void> = new EventEmitter();


onResetClick12() {
  // Reset to the original selected items from parent
  this.currentSelectedItems = [...this.originalSelectedItems];
  this.onReset.emit();
}

onApplyClick12() {
  // Update the original selection with current changes
  this.originalSelectedItems = [...this.currentSelectedItems];
  this.onApply.emit(this.currentSelectedItems);
  this.passSelectedItems();
}

onResetClick() {
  this.selectedItems = [];
  this.onReset.emit(); // notify parent if needed
}

onApplyClick() {
  // this.tempSelectedItems=[...this.selectedItems];
  this.onApply.emit(this.selectedItems); // send selected items to parent
}
  ngAfterViewChecked() {
    
    
    setTimeout(() => {
      let listItems = document.querySelectorAll(".category-filter .multiselect-item-checkbox");
      if(listItems.length > 0){
        listItems.forEach((element:any, index:any) => {
          if(this.dropdownList?.length && this.dropdownList[index] && this.dropdownList[index].isNested == true){
              element.style = "padding-left: 38px !important";
          }
        });
      }
      }, 900);
  }

  ngOnChanges (changes: SimpleChanges) {
     // Handle changes to selectedItems from parent
     if (changes['selectedItems']) {
      this.originalSelectedItems = [...changes['selectedItems'].currentValue];
      this.currentSelectedItems = [...changes['selectedItems'].currentValue];
    }

    // Handle clear filter
    if (this.clearfilter) {
      this.originalSelectedItems = [];
      this.currentSelectedItems = [];
      this.passSelectedItems();
    }
  
  }

  
  onItemSelectOld(item: any, dropdownList: any) {
    if (item.id == 0) {
      // Select All case - select everything
      this.selectedItems = [...dropdownList];
      // Also select all subcategories if they exist
      dropdownList.forEach((dropdownItem: any) => {
        if (dropdownItem?.subcategories?.length > 0) {
          this.selectedItems.push(...dropdownItem.subcategories);
        }
      });
    } else {
      // Normal item selection
      dropdownList.forEach((dropdownItem: any) => {
        if (item.name == dropdownItem.name && dropdownItem?.subcategories?.length > 0) {
          dropdownItem.subcategories.forEach((subDropdownItem: any) => {
            this.selectedItems.push(subDropdownItem);
          });
        }
      });
  
      this.selectedItems.push(item);
  
      // Check if all items are now selected (excluding id=0)
      const allItems = this.getAllSelectableItems(dropdownList);
      const allSelected = allItems.every(selectableItem => 
        this.selectedItems.some((selected :any) => 
          selected[this.dropdownSettings.idField] === selectableItem[this.dropdownSettings.idField]
        )
      );
  
      // If all items are selected, add the "Select All" option (id=0)
      if (allSelected) {
        const selectAllItem = dropdownList.find((d: any) => d.id === 0);
        if (selectAllItem && !this.selectedItems.some((item : any) => item.id === 0)) {
          this.selectedItems.push(selectAllItem);
        }
      }
    }
    
    // Remove duplicates
    this.selectedItems = [...new Map(this.selectedItems.map((item :any) => 
      [item[this.dropdownSettings.idField], item])).values()];
    
  
    this.passSelectedItems();
  }

  onItemSelect(item: any, dropdownList: any) {
    if (item.id == 0) {
      // Select All case - select everything
      this.selectedItems = [...dropdownList];
      // Also select all subcategories if they exist
      dropdownList.forEach((dropdownItem: any) => {
        if (dropdownItem?.subcategories?.length > 0) {
          this.selectedItems.push(...dropdownItem.subcategories);
        }
      });
    } else {
      // Normal item selection
      dropdownList.forEach((dropdownItem: any) => {
        if (item.name == dropdownItem.name && dropdownItem?.subcategories?.length > 0) {
          dropdownItem.subcategories.forEach((subDropdownItem: any) => {
            this.selectedItems.push(subDropdownItem);
          });
        }
      });
  
      this.selectedItems.push(item);
  
      // Check if all subcategories of a parent are selected
      dropdownList.forEach((dropdownItem: any) => {
        if (dropdownItem?.subcategories?.length > 0) {
          const allSubcategoriesSelected = dropdownItem.subcategories.every(
            (subItem: any) => this.selectedItems.some(
              (selected: any) => selected[this.dropdownSettings.idField] === subItem[this.dropdownSettings.idField]
            )
          );
  
          // If all subcategories are selected, add the parent category
          if (allSubcategoriesSelected) {
            const isParentAlreadySelected = this.selectedItems.some(
              (selected: any) => selected[this.dropdownSettings.idField] === dropdownItem[this.dropdownSettings.idField]
            );
            if (!isParentAlreadySelected) {
              this.selectedItems.push(dropdownItem);
            }
          }
        }
      });
  
      // Check if all items are now selected (excluding id=0)
      const allItems = this.getAllSelectableItems(dropdownList);
      const allSelected = allItems.every(selectableItem => 
        this.selectedItems.some((selected: any) => 
          selected[this.dropdownSettings.idField] === selectableItem[this.dropdownSettings.idField]
        )
      );
  
      // If all items are selected, add the "Select All" option (id=0)
      if (allSelected) {
        const selectAllItem = dropdownList.find((d: any) => d.id === 0);
        if (selectAllItem && !this.selectedItems.some((item: any) => item.id === 0)) {
          this.selectedItems.push(selectAllItem);
        }
      }
    }
  
    // Remove duplicates
    this.selectedItems = [...new Map(this.selectedItems.map((item: any) => 
      [item[this.dropdownSettings.idField], item])).values()];
  
    
    this.passSelectedItems();
  }
  
  // Helper method to get all selectable items (excluding id=0)
  getAllSelectableItems(dropdownList: any[]): any[] {
    const items: any[] = [];
    
    dropdownList.forEach(dropdownItem => {
      if (dropdownItem.id !== 0) { // Exclude the "Select All" item itself
        if (dropdownItem?.subcategories?.length > 0) {
          items.push(...dropdownItem.subcategories);
        } else {
          items.push(dropdownItem);
        }
      }
    });
    
    return items;
  }

 
  
  onItemDeSelectOld(item: any, dropdownList: any) {
    let index = null;
    
    // If item.id == 0 is deselected, deselect all
    if (item.id == 0) {
      this.tempSelectedItems=this.dropdownList;
      this.selectedItems = [];
    } else {
      // First check if item.id == 0 is in selectedItems and remove it
      index = this.selectedItems.findIndex((data: any) => data.id == 0);
      if (index != -1) {
        this.selectedItems.splice(index, 1);
      }
  
      // Then handle the normal deselection logic
      dropdownList.forEach((dropdownItem: any) => {
        if (dropdownItem?.subcategories?.length > 0) {
          if (item.name == dropdownItem.name) {
            dropdownItem?.subcategories.forEach((subDropdownItem: any) => {
              index = this.selectedItems.findIndex((data: any) => data.name == subDropdownItem.name);
              if (index != -1) {
                this.selectedItems.splice(index, 1);
              }
            });
          } else {
            dropdownItem?.subcategories.forEach((subDropdownItem: any) => {
              if (subDropdownItem.name == item.name) {
                index = this.selectedItems.findIndex((data: any) => data.name == dropdownItem.name);
                if (index != -1) {
                  this.selectedItems.splice(index, 1);
                }
              }
            });
          }
        }
      });
  
      index = this.selectedItems.findIndex((data: any) => data[this.dropdownSettings.idField] == item[this.dropdownSettings.idField]);
      if (index != -1) {
        this.selectedItems.splice(index, 1);
      }
    }
    
    
    this.passSelectedItems();
  }

  onItemDeSelect(item: any, dropdownList: any) {
    let index = null;
    
    // If "Select All" (id=0) is deselected, deselect everything
    if (item.id == 0) {
      this.selectedItems = [];
    } else {
      // Remove "Select All" (id=0) if it exists (since not all items are selected now)
      index = this.selectedItems.findIndex((data: any) => data.id == 0);
      if (index != -1) {
        this.selectedItems.splice(index, 1);
      }
  
      // Handle normal deselection
      index = this.selectedItems.findIndex((data: any) => 
        data[this.dropdownSettings.idField] == item[this.dropdownSettings.idField]
      );
      if (index != -1) {
        this.selectedItems.splice(index, 1);
      }
  
      // Check if the deselected item is a subcategory
      dropdownList.forEach((dropdownItem: any) => {
        if (dropdownItem?.subcategories?.length > 0) {
          // Case 1: Deselecting a subcategory directly
          if (dropdownItem.subcategories.some((sub: any) => 
            sub[this.dropdownSettings.idField] === item[this.dropdownSettings.idField]
          )) {
            // Remove the parent category if it exists (since not all subcategories are selected)
            const parentIndex = this.selectedItems.findIndex((selected: any) => 
              selected[this.dropdownSettings.idField] === dropdownItem[this.dropdownSettings.idField]
            );
            if (parentIndex !== -1) {
              this.selectedItems.splice(parentIndex, 1);
            }
          }
          // Case 2: Deselecting a parent category → deselect all its subcategories
          else if (dropdownItem[this.dropdownSettings.idField] === item[this.dropdownSettings.idField]) {
            dropdownItem.subcategories.forEach((sub: any) => {
              const subIndex = this.selectedItems.findIndex((selected: any) =>
                selected[this.dropdownSettings.idField] === sub[this.dropdownSettings.idField]
              );
              if (subIndex !== -1) {
                this.selectedItems.splice(subIndex, 1);
              }
            });
          }
        }
      });
    }
    
  
    this.passSelectedItems();
  }

  
  
  passSelectedItems() {
    if (!this.clearfilter) {
      this.onSelectionChange.emit({
        value: [...new Map(this.selectedItems.map((item: any) =>
          [item[this.dropdownSettings.idField], item])).values()]
      });
    }
  }

  toggleDropdownState(event:any) {
    this.isToggle = !this.isToggle; // Toggle the state
  }

  compareWithStringify(arr1: any[], arr2: any[]): boolean {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  }
  handleOutsideClick(event: MouseEvent) {
    const dropdownContainer = document.querySelector('.custom-multi-dropdown-container');
    if (dropdownContainer && !dropdownContainer.contains(event.target as Node)) {
      this.isToggle = false; // Close dropdown if clicked outside
      //if both same then apply already done,if selected item is other than tempselected then it has done some changes but not saved yet,in this case we will show add tempdata in selected
      let result= this.compareWithStringify(this.tempSelectedItems,this.selectedItems);
      if(!result && this.tempSelectedItems.length>0){
        this.selectedItems = [...this.tempSelectedItems];
        this.passSelectedItems();
        this.onApply.emit(this.selectedItems); 
      }
    }
  }


}
